import { BaseRoutes, RoutesConstant } from '../constants/routes.constant';

export const isBaseRoute = (pathname: string): boolean =>
  BaseRoutes.includes(pathname)

export const getClosestBaseRoute = (pathname: string): string => {
  if (pathname.includes(RoutesConstant.INTERNSHIP_R)) {
    return RoutesConstant.INTERNSHIPS;
  }
  if (pathname.includes(`${RoutesConstant.CANDIDATES_GROUPS.SEARCH}/${RoutesConstant.CANDIDATE_R}`)) {
    return RoutesConstant.CANDIDATES_GROUPS.SEARCH;
  }
  if (pathname.includes(RoutesConstant.CANDIDATES_GROUPS.SEARCH)) {
    return RoutesConstant.REPORT;
  }

  for (const route of BaseRoutes) {
    // Checking if current path have base route as it's substring
    if (pathname.includes(route)) {
      return route;
    }
  }

  return RoutesConstant.DASHBOARD;
};
